export default {
  init() {
    const slider = $('.intro-content-slider'),
          eventSlider = $('.events-carousel');

    var sliderSettings = {
      adaptiveHeight: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnHover: true,
      dots: false,
      infinite: true,
      prevArrow: $('.prev-button'),
      nextArrow: $('.next-button')
    },
    eventSliderSettings = {
      adaptiveHeight: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnHover: false,
      dots: false,
      infinite: true,
      prevArrow: $('.event-slider-prev-button'),
      nextArrow: $('.event-slider-next-button')
    }

    slider.slick(sliderSettings);
    eventSlider.slick(eventSliderSettings);

  }
}
